import { ReactElement, ReactNode } from 'react';
import { Typography } from 'antd';

import { ReadonlyTextProps } from './interfaces';

const isEmpty = (value: ReactNode): boolean => value === null || value === undefined || value === '';

export const ReadonlyText = ({ value }: ReadonlyTextProps): ReactElement =>
  isEmpty(value) ? <Typography.Text type="secondary">-</Typography.Text> : <Typography.Text>{value}</Typography.Text>;
